import { AfterViewInit, Component } from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { useDispatcher } from '../../../store.decorator';

import { TranslationKeyMap } from './ca-analysis-dialog.i18n';
import { CaAnalysisDialogService } from './ca-analysis-dialog.service';
import { minMax } from './state/min-max.action';

@Component({
    selector: 'cmps-ca-analysis-dialog',
    templateUrl: './ca-analysis-dialog.component.html',
    host: {
        class: 'cmps-ca-analysis-dialog',
    },
})
export class CaAnalysisDialogComponent implements AfterViewInit {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CaAnalysisDialogComponent,
            void
        >,
        /** @private */ readonly _service: CaAnalysisDialogService,
    ) {}

    ngAfterViewInit(): void {
        this._service.callStatusService.buttons = [];
    }

    /** @private **/
    _onMinMaxClick(): void {
        useDispatcher(
            this._service,
            minMax({ minimized: !(this._service.state?.minimized ?? false) }),
        );
    }
}
